// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo

import { LatLng } from './LatLng';

import type { LatLngModelType } from './LatLng';

type AccuracyCategoryEnum =
    | 'HIGHLY_ACCURATE'
    | 'POSSIBLY_ACCURATE'
    | 'CANT_VERIFY'
    | 'POSSIBLY_INACCURATE'
    | 'HIGHLY_INACCURATE';

export type GeocodeVerifiedGeometryModelType = {
    locationId: string,
    geocodedLatLng: ?LatLngModelType,
    accuracyCategory?: ?AccuracyCategoryEnum
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class GeocodeVerifiedGeometry extends ImmutableModel {
    static fromJS(
        json: GeocodeVerifiedGeometryModelType
    ): GeocodeVerifiedGeometry {
        const state: Object = Object.assign({}, json);
        state.geocodedLatLng = state.geocodedLatLng
            ? LatLng.fromJS(state.geocodedLatLng)
            : state.geocodedLatLng;
        return new this(Immutable.Map(state));
    }

    toJS(): GeocodeVerifiedGeometryModelType {
        const js: GeocodeVerifiedGeometryModelType = {
            locationId: this.locationId,
            geocodedLatLng: this.geocodedLatLng
                ? this.geocodedLatLng.toJS()
                : this.geocodedLatLng
        };

        if (this.accuracyCategory != null) {
            js.accuracyCategory = this.accuracyCategory;
        }

        return js;
    }

    get locationId(): string {
        return this._state.get('locationId');
    }

    setLocationId(locationId: string): this {
        return this.clone(this._state.set('locationId', locationId));
    }

    get geocodedLatLng(): ?LatLng {
        return this._state.get('geocodedLatLng');
    }

    setGeocodedLatLng(geocodedLatLng: ?LatLng): this {
        return this.clone(this._state.set('geocodedLatLng', geocodedLatLng));
    }

    get accuracyCategory(): ?AccuracyCategoryEnum {
        return this._state.get('accuracyCategory');
    }

    setAccuracyCategory(accuracyCategory: ?AccuracyCategoryEnum): this {
        return this.clone(
            this._state.set('accuracyCategory', accuracyCategory)
        );
    }
}
